export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGOUT = 'USER_LOGOUT';

export const api = {
  // "url": "https://www.ecg-surveys.com"
    "url": ""
};

export const DEFAULT_PRICES = {
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
};

export const SOUTHERN_CALIFORNIA_PROPERTY_ZONES = [
  {
    "key": "1",
    "name": "Zone I (LAX and LA County Beach Areas)"
  },
  {
    "key": "2",
    "name": "Zone II (Westside or Beverly Hills Area)"
  },
  {
    "key": "3",
    "name": "Zone III (Downtown LA, Valley or Other Areas)"
  },
  {
    "key": "4",
    "name": "Zone IV (Orange County Areas)"
  },
  {
    "key": "5",
    "name": "Zone V (Santa Barbara Areas)"
  },
  {
    "key": "6",
    "name": "Zone VI (Palms Springs/Desert Areas)"
  },
  {
    "key": "7",
    "name": "Zone VII (San Diego Areas)"
  }
];

export const LA_3_PROPERTY_ZONES = [
  {
    "key": "1",
    "name": "Zone I (LAX and LA County Beach Areas)"
  },
  {
    "key": "2",
    "name": "Zone II (Westside or Beverly Hills Area)"
  },
  {
    "key": "3",
    "name": "Zone III (Downtown LA, Valley or Other Areas)"
  }
];

export const ARIZONA_PROPERTY_ZONES = [
  {
    "key": "1",
    "name": "Zone I (Phoenix/Scottsdale)"
  },
  {
    "key": "2",
    "name": "Zone II (Tucson)"
  }
];

export const FLORIDA_PROPERTY_ZONES = [
  {
    "key": "1",
    "name": "Zone I (Florida Keys)"
  },
  {
    "key": "2",
    "name": "Zone II (Florida South)"
  }
];

export const NAPA_PROPERTY_ZONES = [
  {
    "key": "1",
    "name": "Zone I (Napa)"
  },
  {
    "key": "2",
    "name": "Zone II (Sonoma)"
  }
];

export const PALO_ALTO_SF_PROPERTY_ZONES = [
  {
    "key": "1",
    "name": "Zone I (Palo Alto)"
  },
  {
    "key": "2",
    "name": "Zone II (San Francisco)"
  }
];

export const ONLY_ONE_ZONES = [
  {
    "key": "1",
    "name": "Zone I"
  }
];

export const SURVEY_TYPES = [
  {
    "key": "1",
    "state": "CA",
    "name": "Southern California",
    "has_luxury": true,
    "has_union": true,
    "has_inn": true,
    "has_golf": true,
    "has_limited": true,
    "zones": SOUTHERN_CALIFORNIA_PROPERTY_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  }
  ,{
    "key": "2",
    "state": "AZ",
    "name": "Arizona",
    "has_luxury": true,
    "has_union": true,
    "has_inn": false,
    "has_golf": false,
    "has_limited": false,
    "zones": ARIZONA_PROPERTY_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },{
    "key": "3",
    "state": "CA",
    "name": "Palo Alto & San Francisco",
    "has_luxury": false,
    "has_union": false,
    "has_inn": false,
    "has_golf": false,
    "has_limited": false,
    "zones": PALO_ALTO_SF_PROPERTY_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },{
    "key": "4",
    "state": "CA",
    "name": "Monterey/Carmel",
    "has_luxury": true,
    "has_union": true,
    "has_inn": true,
    "has_golf": true,
    "has_limited": true,
    "zones": ONLY_ONE_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },{
    "key": "5",
    "state": "GA",
    "name": "Atlanta",
    "has_luxury": true,
    "has_union": true,
    "has_inn": false,
    "has_golf": false,
    "has_limited": false,
    "zones": ONLY_ONE_ZONES,
    "participant_price":275,
    "non_participant_price":1100,
    "hard_copy_price":55
  },{
    "key": "6",
    "state": "CO",
    "name": "Aspen",
    "has_luxury": true,
    "has_union": true,
    "has_inn": false,
    "has_golf": false,
    "has_limited": false,
    "zones": ONLY_ONE_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },{
    "key": "7",
    "state": "ALL",
    "name": "Lake Tahoe",
    "has_luxury": true,
    "has_union": true,
    "has_inn": false,
    "has_golf": false,
    "has_limited": false,
    "zones": ONLY_ONE_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },{
    "key": "8",
    "state": "DC",
    "name": "Washington DC",
    "has_luxury": true,
    "has_union": true,
    "has_inn": false,
    "has_golf": false,
    "has_limited": false,
    "zones": ONLY_ONE_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },
  {
    "key": "9",
    "state": "CA",
    "name": "Berkeley",
    "has_luxury": true,
    "has_union": true,
    "has_inn": false,
    "has_golf": false,
    "has_limited": false,
    "zones": ONLY_ONE_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },
  {
    "key": "11",
    "state": "TX",
    "name": "Texas",
    "has_luxury": true,
    "has_union": true,
    "has_inn": true,
    "has_golf": true,
    "has_limited": true,
    "zones": ONLY_ONE_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },
  {
    "key": "12",
    "state": "CA",
    "name": "Santa Barbara Chamber of Commerce",
    "has_luxury": true,
    "has_union": true,
    "has_inn": true,
    "has_golf": true,
    "has_limited": true,
    "zones": ONLY_ONE_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },
  {
    "key": "13",
    "state": "TN",
    "name": "Nashville, TN",
    "has_luxury": true,
    "has_union": true,
    "has_inn": true,
    "has_golf": true,
    "has_limited": true,
    "zones": ONLY_ONE_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },
  {
    "key": "14",
    "state": "FL",
    "name": "Florida",
    "has_luxury": true,
    "has_union": true,
    "has_inn": true,
    "has_golf": true,
    "has_limited": true,
    "zones": FLORIDA_PROPERTY_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },
  {
    "key": "16",
    "state": "CA",
    "name": "Napa Valley",
    "has_luxury": true,
    "has_union": true,
    "has_inn": true,
    "has_golf": true,
    "has_limited": true,
    "zones": NAPA_PROPERTY_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },
  {
    "key": "17",
    "state": "CA",
    "name": "Los Angeles Exempt Survey",
    "has_luxury": true,
    "has_union": true,
    "has_inn": true,
    "has_golf": true,
    "has_limited": true,
    "zones": LA_3_PROPERTY_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  },
  {
    "key": "999",
    "state": "ALL",
    "name": "RERG",
    "has_luxury": true,
    "has_union": true,
    "has_inn": true,
    "has_golf": true,
    "has_limited": true,
    "zones": ONLY_ONE_ZONES,
    "participant_price":675,
    "non_participant_price":1100,
    "hard_copy_price":55
  }
];

export const USA_STATES = [
  {
      "name": "Alabama",
      "key": "AL"
  },
  {
      "name": "Alaska",
      "key": "AK"
  },
  {
      "name": "American Samoa",
      "key": "AS"
  },
  {
      "name": "Arizona",
      "key": "AZ"
  },
  {
      "name": "Arkansas",
      "key": "AR"
  },
  {
      "name": "California",
      "key": "CA"
  },
  {
      "name": "Colorado",
      "key": "CO"
  },
  {
      "name": "Connecticut",
      "key": "CT"
  },
  {
      "name": "Delaware",
      "key": "DE"
  },
  {
      "name": "District Of Columbia",
      "key": "DC"
  },
  {
      "name": "Federated States Of Micronesia",
      "key": "FM"
  },
  {
      "name": "Florida",
      "key": "FL"
  },
  {
      "name": "Georgia",
      "key": "GA"
  },
  {
      "name": "Guam",
      "key": "GU"
  },
  {
      "name": "Hawaii",
      "key": "HI"
  },
  {
      "name": "Idaho",
      "key": "ID"
  },
  {
      "name": "Illinois",
      "key": "IL"
  },
  {
      "name": "Indiana",
      "key": "IN"
  },
  {
      "name": "Iowa",
      "key": "IA"
  },
  {
      "name": "Kansas",
      "key": "KS"
  },
  {
      "name": "Kentucky",
      "key": "KY"
  },
  {
      "name": "Louisiana",
      "key": "LA"
  },
  {
      "name": "Maine",
      "key": "ME"
  },
  {
      "name": "Marshall Islands",
      "key": "MH"
  },
  {
      "name": "Maryland",
      "key": "MD"
  },
  {
      "name": "Massachusetts",
      "key": "MA"
  },
  {
      "name": "Michigan",
      "key": "MI"
  },
  {
      "name": "Minnesota",
      "key": "MN"
  },
  {
      "name": "Mississippi",
      "key": "MS"
  },
  {
      "name": "Missouri",
      "key": "MO"
  },
  {
      "name": "Montana",
      "key": "MT"
  },
  {
      "name": "Nebraska",
      "key": "NE"
  },
  {
      "name": "Nevada",
      "key": "NV"
  },
  {
      "name": "New Hampshire",
      "key": "NH"
  },
  {
      "name": "New Jersey",
      "key": "NJ"
  },
  {
      "name": "New Mexico",
      "key": "NM"
  },
  {
      "name": "New York",
      "key": "NY"
  },
  {
      "name": "North Carolina",
      "key": "NC"
  },
  {
      "name": "North Dakota",
      "key": "ND"
  },
  {
      "name": "Northern Mariana Islands",
      "key": "MP"
  },
  {
      "name": "Ohio",
      "key": "OH"
  },
  {
      "name": "Oklahoma",
      "key": "OK"
  },
  {
      "name": "Oregon",
      "key": "OR"
  },
  {
      "name": "Palau",
      "key": "PW"
  },
  {
      "name": "Pennsylvania",
      "key": "PA"
  },
  {
      "name": "Puerto Rico",
      "key": "PR"
  },
  {
      "name": "Rhode Island",
      "key": "RI"
  },
  {
      "name": "South Carolina",
      "key": "SC"
  },
  {
      "name": "South Dakota",
      "key": "SD"
  },
  {
      "name": "Tennessee",
      "key": "TN"
  },
  {
      "name": "Texas",
      "key": "TX"
  },
  {
      "name": "Utah",
      "key": "UT"
  },
  {
      "name": "Vermont",
      "key": "VT"
  },
  {
      "name": "Virgin Islands",
      "key": "VI"
  },
  {
      "name": "Virginia",
      "key": "VA"
  },
  {
      "name": "Washington",
      "key": "WA"
  },
  {
      "name": "West Virginia",
      "key": "WV"
  },
  {
      "name": "Wisconsin",
      "key": "WI"
  },
  {
      "name": "Wyoming",
      "key": "WY"
  }
];



// WEBPACK FOOTER //
// ./src/constants.js